var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"div",class:[("container container--" + _vm.size), { 'container--styled': _vm.defaultStyling }]},[(_vm.$slots.default)?_c('div',{staticClass:"container__inner",attrs:{"data-cy":_vm.dataCyKey}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }